import axios from "axios";

export const JoinWaitListAPI = (data) => axios
  .post(process.env.REACT_APP_API_URL + '/account/waitlist', data);
